/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { type FileUpload } from '@dm/ang';

@Injectable({ providedIn: 'root' })
export class PatchService {
    /**
     * LiveUI的后缀名检测算法有bug，这里用补丁函数重新检测一次
     * 使用时需要注意绑定this对象
     * @param event 事件对象
     * @param uploadComp 文件上传组件的引用
     * @param oriOnSelectFn 原始onSelect函数
     */
    onSelectPatch(event, uploadComp: FileUpload, oriOnSelectFn: () => void): void {
        if (event.files && event.files.length) {
            const file: File = event.files[0].file;
            const fileSuffix = file.name.slice(file.name.lastIndexOf('.'));

            let result = false;
            const allowSuffixArr = uploadComp.allowFileSuffix.split(',').map((item) => item.trim());
            for (const suffix of allowSuffixArr) {
                if (suffix === fileSuffix) {
                    result = true;
                }
            }

            if (!result) {
                uploadComp.msgs.push({
                    severity: 'error',
                    summary: uploadComp.invalidFileTypeMessageSummary.replace('{0}', file.name),
                    detail: uploadComp.invalidFileTypeMessageDetail.replace('{0}', uploadComp.allowFileSuffix),
                });
                uploadComp.onValidateError.emit({
                    fileName: file.name,
                    errorType: uploadComp.invalidFileTypeMessageSummary.replace('{0}: ', ''),
                    errorDetail: uploadComp.invalidFileTypeMessageDetail.replace('{0}', uploadComp.allowFileSuffix),
                });
                uploadComp.files = [];
                uploadComp.uploadStatus = [];
            }
        }

        oriOnSelectFn.call(this, event);
    }
}
